var _style, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedExclamationMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.outline-red-exclamation-icon-st0{display:none;}\n\t.outline-red-exclamation-icon-st1{fill:#C72909;}\n\t.outline-red-exclamation-icon-st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "outline-red-exclamation-icon-st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "outline-red-exclamation-icon-st1",
    d: "M25,7C15.1,7,7,15.1,7,25s8.1,18,18,18s18-8.1,18-18S34.9,7,25,7z M25,41c-8.8,0-16-7.2-16-16S16.2,9,25,9 s16,7.2,16,16S33.8,41,25,41z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "outline-red-exclamation-icon-st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "outline-red-exclamation-icon-st1",
    d: "M25,35.1c-0.5,0-0.9-0.2-1.3-0.6c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.5,0.2-0.9,0.6-1.3c0.4-0.4,0.8-0.6,1.3-0.6 s0.9,0.2,1.3,0.6c0.4,0.4,0.6,0.8,0.6,1.3c0,0.5-0.2,0.9-0.6,1.3C25.9,34.9,25.5,35.1,25,35.1z M26.2,29.3h-2.5l-0.5-12.4h3.4 L26.2,29.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedExclamationMark);
export default __webpack_public_path__ + "static/media/red_exclamation_mark.0d08206290a6e929e4d4c278f62cafef.svg";
export { ForwardRef as ReactComponent };